import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./hooks/useAuth";
import { ExchangeRateProvider } from "./hooks/usePriceConversion";
import { BrowserRouter } from "react-router-dom";
import { WagmiConfig, createClient, configureChains } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { mainnet, polygon, polygonMumbai } from "wagmi/chains";
import { ENVIRONMENT } from "./globalVariables";

const { chains, provider, webSocketProvider } = configureChains(
  [polygon],
  [publicProvider()]
);

const client = createClient({
  autoConnect: true,
  provider,
  webSocketProvider,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <WagmiConfig client={client}>
        <ExchangeRateProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ExchangeRateProvider>
      </WagmiConfig>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
